export default "__VITE_ASSET__Ci79wGkL__"